const routes = [
    {
        path: "/districts",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "district_index"
        }
    }
];

export default routes;
